import { render, staticRenderFns } from "./waitTransport.vue?vue&type=template&id=54ea0268&scoped=true"
import script from "./waitTransport.vue?vue&type=script&lang=js"
export * from "./waitTransport.vue?vue&type=script&lang=js"
import style0 from "./waitTransport.vue?vue&type=style&index=0&id=54ea0268&prod&lang=css"
import style1 from "./waitTransport.vue?vue&type=style&index=1&id=54ea0268&prod&scoped=true&lang=scss"
import style2 from "./waitTransport.vue?vue&type=style&index=2&id=54ea0268&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea0268",
  null
  
)

export default component.exports